// extracted by mini-css-extract-plugin
export default {"section":"TransitTab_section__B3uq1","title":"TransitTab_title__b8Kd5"};